export default __webpack_public_path__ + "static/media/hero.06c2bd41.jpg";